/*** ALL ROUTES ARE DEFINDED HERE ***/

const ROUTE_NAMES = {
  BASE_ROUTE: "/",
  PUBLIC_ROUTES: {
    SUPPORT: "/support",
    TERM_AND_CONDITIONS: "/term-and-conditions",
    CONTACT_US: "/contact-us",
    FAQ: "/faq",
    PRIVACY_POLICY: "/privacy-policy",
  },

  MAIN_ROUTES: {
    DASHBOARD: "/dashboard",
    USERS: "/users",
    USER: "/users/:id",
    CMS: "/content-management",
    PROFILE: "/profile",
    SITES: "/sites",
    ADD_SITES: "/sites/add-site",
    SITES_DETAIL: "/sites/:siteId",
    UPDATE_SITE: "/sites/update-site/:siteId",
    CITIES: "/cities",
    CITY_DETAIL: "/cities/:cityId",
    CITY_UPDATE: "/cities/update-city/:cityId",
    REPORT_MANAGEMENT: "/report-management",
    POST_DETAILS: "post-details",
    POST_LISTING: "/report-manager/post-lisiting",
    FEEDBACK: "/feedback",
    FEEDBACK_DETAILS: "/feedback/:feedbackId",
    QUERIES: "/queries",
    QUERY_DETAILS: "/queries/:query",
    HOT_TO_VIDEOS: "/how-to-videos",
    EMAILS: "/emails",
    EMAILS_DETAILS: "/emails/:id",
    ARTICLES: "/articles",
    ADD_ARTICLES: "/articles/add",
    VIEW_EDIT_ARTICLES: "/articles/edit/:articleId",
    RATINGS_AND_REVIEWS: "/ratings-and-reviews",
  },
};

const { PUBLIC_ROUTES, MAIN_ROUTES, BASE_ROUTE } = ROUTE_NAMES;
/**
 * @description Central place holding display name + description for every route.
 * Keyed by the same path values defined in ROUTE_NAMES, so paths are never
 * retyped or hardcoded elsewhere.
 */

export const ROUTE_META = {
  [BASE_ROUTE]: {
    name: "Home",
    description: "Overview of your account and quick access to key sections.",
  },

  // ---------- Public Routes ----------
  [PUBLIC_ROUTES.SUPPORT]: {
    name: "Support",
    description: "Get help and find answers to common issues.",
  },
  [PUBLIC_ROUTES.TERM_AND_CONDITIONS]: {
    name: "Terms & Conditions",
    description: "Review the terms and conditions of using this platform.",
  },
  [PUBLIC_ROUTES.CONTACT_US]: {
    name: "Contact Us",
    description: "Reach out to the team for queries or support.",
  },
  [PUBLIC_ROUTES.FAQ]: {
    name: "FAQ",
    description: "Answers to frequently asked questions.",
  },
  [PUBLIC_ROUTES.PRIVACY_POLICY]: {
    name: "Privacy Policy",
    description: "Learn how your data is collected, used, and protected.",
  },

  // ---------- Main Routes ----------
  [MAIN_ROUTES.DASHBOARD]: {
    name: "Dashboard",
    description: "Key metrics and activity at a glance.",
  },
  [MAIN_ROUTES.USERS]: {
    name: "Users",
    description: "View, search, and manage all registered users.",
  },
  [MAIN_ROUTES.USER]: {
    name: "User Details",
    description: "View and manage details for this user.",
  },
  [MAIN_ROUTES.CMS]: {
    name: "Content Management",
    description: "Manage site content, pages, and static assets.",
  },
  [MAIN_ROUTES.PROFILE]: {
    name: "Profile",
    description: "View and update your account details and preferences.",
  },
  [MAIN_ROUTES.SITES]: {
    name: "Sites",
    description: "Manage dive sites listed on the platform.",
  },
  [MAIN_ROUTES.ADD_SITES]: {
    name: "Add Site",
    description: "Add a new dive site to the platform.",
  },
  [MAIN_ROUTES.SITES_DETAIL]: {
    name: "Site Details",
    description: "View detailed information for this dive site.",
  },
  [MAIN_ROUTES.UPDATE_SITE]: {
    name: "Update Site",
    description: "Edit details for this dive site.",
  },
  [MAIN_ROUTES.CITIES]: {
    name: "Cities",
    description: "Manage cities associated with dive locations.",
  },
  [MAIN_ROUTES.CITY_DETAIL]: {
    name: "City Details",
    description: "View detailed information for this city.",
  },
  [MAIN_ROUTES.CITY_UPDATE]: {
    name: "Update City",
    description: "Edit details for this city.",
  },
  [MAIN_ROUTES.REPORT_MANAGEMENT]: {
    name: "Report Management",
    description: "View and manage reports submitted by users.",
  },
  [MAIN_ROUTES.POST_DETAILS]: {
    name: "Post Details",
    description: "View detailed information for this reported post.",
  },
  [MAIN_ROUTES.POST_LISTING]: {
    name: "Post Listing",
    description: "Browse all posts flagged for review.",
  },
  [MAIN_ROUTES.FEEDBACK]: {
    name: "Feedback",
    description: "Browse feedback and ratings shared by users.",
  },
  [MAIN_ROUTES.FEEDBACK_DETAILS]: {
    name: "Feedback Details",
    description: "View detailed feedback submitted by a user.",
  },
  [MAIN_ROUTES.QUERIES]: {
    name: "Queries",
    description: "Review and respond to customer queries and support requests.",
  },
  [MAIN_ROUTES.QUERY_DETAILS]: {
    name: "Query Details",
    description: "View and respond to this customer query.",
  },
  [MAIN_ROUTES.HOT_TO_VIDEOS]: {
    name: "How to Videos",
    description: "Manage tutorial videos shown to users in the app.",
  },
  [MAIN_ROUTES.EMAILS]: {
    name: "Email Template",
    description: "Manage and customize automated email templates.",
  },
  [MAIN_ROUTES.EMAILS_DETAILS]: {
    name: "Email Template Details",
    description: "Update template content and preview before saving.",
  },
  [MAIN_ROUTES.ARTICLES]: {
    name: "Articles",
    description: "Manage articles posts displayed to users.",
  },
  [MAIN_ROUTES.ADD_ARTICLES]: {
    name: "Add Article",
    description: "Create a new article post for users.",
  },
  [MAIN_ROUTES.VIEW_EDIT_ARTICLES]: {
    name: "Edit Article",
    description: "View and edit details for this article post.",
  },
  [MAIN_ROUTES.RATINGS_AND_REVIEWS]: {
    name: "Ratings and Reviews",
    description: "View and edit details for this ratings and reviews.",
  }
};

export default ROUTE_NAMES;
